import { SVGInterface } from "../../interface";

const CalendarClose = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4H7V2H9V4H15V2H17V4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22ZM5 10V20H19V10H5ZM5 6V8H19V6H5ZM9.706 18.707L8.293 17.293L10.586 15L8.293 12.707L9.707 11.293L12 13.586L14.293 11.294L15.707 12.708L13.414 15L15.707 17.293L14.294 18.706L12 16.414L9.707 18.707H9.706Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default CalendarClose;
